import { constants, Yup } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import moment from 'moment'

const {
  locale: {
    key: { CommonValidationMessageKeys }
  }
} = constants

function makeValidationSchema(translate) {
  const requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return Yup.object({
    formType: Yup.string().max(3).required(requiredMessage).nullable(),
    customsProc: Yup.string().max(2).required(requiredMessage).nullable(),
    carrierCode: Yup.string()
      .required(requiredMessage)
      .min(4, 'Should be a valid 4 character Carrier Code')
      .max(4, 'Should be a valid 4 character Carrier Code')
      .matches(
        '^[a-zA-Z0-9-]{4}$',
        'Carrier Code must be 4 characters long and cannot contain special characters.'
      ),
    originalCCN: Yup.string()
      .trim()
      .required(requiredMessage)
      .min(5, 'Min length needed is 5.')
      .max(25, 'Max length allowed is 25.')
      .matches('[a-zA-Z0-9]$', 'Only alphanumeric values are allowed.'),
    ccn: Yup.string()
      .trim()
      .required(requiredMessage)
      .min(5, 'Min length needed is 5.')
      .max(25, 'Max length allowed is 25.')
      .matches('[a-zA-Z0-9]$', 'Only alphanumeric values are allowed')
      .test(
        'Check Carrier Code Prefix',
        'CCN should be prefixed with Carrier Code.',
        function () {
          let carrierCode = this.parent['carrierCode']
          let ccn = this.parent['ccn']
          if (carrierCode && ccn) {
            return ccn.startsWith(carrierCode) ? true : false
          }
        }
      ),
    mot: Yup.string()
      .required(requiredMessage)
      .max(1, 'Max length allowed is 1.')
      .nullable(),
    specialIns: Yup.string()
      .trim()
      .max(60, 'Max length allowed is 60.')
      .matches(
        '[a-zA-Z0-9-.s]*$',
        'Special Instructions cannot contain special characters.'
      )
      .nullable(),
    deliveryCountry: Yup.string().required(requiredMessage).nullable(),
    deliveryCity: Yup.string()
      .trim()
      .max(25, 'Max length allowed is 25.')
      .required(requiredMessage)
      .matches('[a-zA-Zs]$', 'Only alphabets are allowed'),
    deliveryTerminalName: Yup.lazy((value) =>
      value === ''
        ? Yup.string().required(requiredMessage)
        : Yup.string().required(requiredMessage)
            .trim()
            .min(1, 'Min length needed is 1.')
            .max(25, 'Max length allowed is 25.')
            .matches(
              "^[a-zA-Z0-9-. ]*$",
              'Place of Delivery (Terminal Name) cannot contain special characters like < > ! | { } [ ] =  ` ~ '
            )
            .nullable()
    ),
    scheduledSubmissionFlag: Yup.boolean().required(requiredMessage),
    scheduleDateAndTime: Yup.string()
      .when('scheduledSubmissionFlag', {
        is: true,
        then: Yup.string()
          .required('Please select a valid date.')
          .test(
            'scheduleDateAndTime',
            'Please select a valid Future Scheduled Date Time in yyyy-mm-dd HH:mm:ss format.',
            (value) => {
              var formattedDate = moment(value).format('YYYY-MM-DD')
              var formattedToday = moment(today).format('YYYY-MM-DD')
              return moment(formattedDate).isAfter(formattedToday, 'days')
            }
          )
      })
      .nullable(),
    templateFlag: Yup.boolean().required(requiredMessage),
    templateName: Yup.string()
      .when('templateFlag', {
        is: true,
        then: Yup.string()
          .trim()
          .required(requiredMessage)
          .min(1, 'Min length needed is 1')
          .max(50, 'Max length is 50')
          .matches('[a-zA-Z0-9s]$', 'Only alphanumeric characters are allowed.')
      })
      .nullable(),
    hdrStatus: Yup.string().nullable(),
    messageFunction: 
    Yup.string()
      .when('hdrStatus', {
        is: (value) => value === '1000',
        then: Yup.string().test(
          'messageFunction',
          'Confirmed record cannot be submitted as Original.',
          function (value) {
            return value !== "9"
          }
        )
      })
      .when('hdrStatus', {
        is: (value) => (value === '20' || value === '21' || value === '28'),
        then: Yup.string().test(
          'messageFunction',
          'Error status record should be submitted as Original.',
          function (value) {
            return value === "9"
          }
        )
      })
      .when('hdrStatus', {
        is: (value) => (value === '29'),
        then: Yup.string().test(
          'messageFunction',
          'Error status record should be submitted as Original / Change.',
          function (value) {
            return (value == "9" || value == "4")
          }
        )
      })      
      .when('hdrStatus', {
        is: (value) => (value === '22'),
        then: Yup.string().test(
          'messageFunction',
          'Conformance/Syntax Error status record should be submitted as Change.',
          function (value) {
            return value === "4"
          }
        )
      })
      .when('hdrStatus', {
        is: (value) => (value === '1003' || value === '1004'),
        then: Yup.string().test(
          'messageFunction',
          'Cancel Accepted/Rejected record should be submitted as Original.',
          function (value) {
            return value === "9"
          }
        )
      })
      .nullable()
      .required(requiredMessage),
    aciAirPartyList: Yup.array(),
    aciAirItemList: Yup.array(),
    aciAirStatusNotifyList: Yup.array()
  })
}

export default makeValidationSchema
